module.exports = __webpack_public_path__ + "img/logo.5789e627.svg";